import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { RouteError } from "@/shared/components/RouteError";
import { hasPermission } from "@/shared/utils/permissions";

// BEL-587: the map now also renders station geofence polygons, so either
// `admin.devices.read` (BEL-743's original gate) or `admin.stations.read`
// grants access — a platform-admin with only one of the two still sees the
// bikes/stations relevant to their permission (station layer is separately
// gated inside `useDeviceMapData`).
export const Route = createFileRoute("/app/admin/map")({
  beforeLoad: ({ context }) => {
    const canReadDevices = hasPermission(
      context.auth.user,
      "admin.devices.read",
    );
    const canReadStations = hasPermission(
      context.auth.user,
      "admin.stations.read",
    );
    if (!canReadDevices && !canReadStations) {
      throw redirect({ to: "/app" });
    }
  },
  errorComponent: ({ error }) => <RouteError error={error} />,
  component: () => <Outlet />,
});
